<!-- Auf app-info-modal aufgesetzt: Overlay, Animation und Blende sind dort
     schon gelöst, hier kommt nur der Inhalt dazu. -->
<app-info-modal [open]="open" (openChange)="dismiss()">
  <div class="confirm-modal__content">
    <p class="header-title">{{ title }}</p>
    <div class="spacer spacer-1"></div>
    <p class="paragraph">{{ text }}</p>
    <div class="spacer spacer-3"></div>

    <!-- Weitermachen zuerst und farbig: das Abbrechen verwirft die Eingaben. -->
    <app-button
      [label]="dismissLabel"
      [buttonType]="ButtonType.Blue"
      [fullWidth]="true"
      [extraHeight]="true"
      (action)="dismiss()"
    ></app-button>
    <div class="spacer spacer-2"></div>
    <app-button
      [label]="confirmLabel"
      [buttonType]="ButtonType.Secondary"
      [fullWidth]="true"
      [extraHeight]="true"
      (action)="confirm()"
    ></app-button>
  </div>
</app-info-modal>
